export const Regions: string[] = [
  'pha',
  'stc',
  'jhc',
  'plk',
  'kvk',
  'ulk',
  'lbk',
  'hkk',
  'pak',
  'vys',
  'jhm',
  'olk',
  'msk',
  'zlk',
];
